export default __webpack_public_path__ + "static/media/DavidPetkovski.0ac4a12a.png";